import { CrossSellingPointer } from "../../others/crossSellingPointer.js";
import { RCB } from "../names.js";
/**
 * Plugins list and headline.
 */ const crossRcbGdprCompliant = ()=>CrossSellingPointer.waitForVisibleElement("body.wp-admin.plugins-php #wpbody-content > div.wrap > h1:first", RCB, "gdpr-compliant");
export { crossRcbGdprCompliant };
